import { useParams } from 'react-router-dom';
import { useWorkflowGet } from '../hooks/use-workflow.hook';
import { memo } from 'react';
import WorkflowDetailsComponent from '../components/workflow-details.component';
import HeaderRow from '../../../../common/HeaderRow';
import { useTranslation } from 'react-i18next';
import ErrorFallback from '../../../../common/ErrorFallback';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { WithPermissionCheck } from '../../../../auth/WithPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const WorkflowDetailsContainer = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data, isLoading, error } = useWorkflowGet(id || '');

  if (!id) {
    return (
      <ErrorFallback
        details={t('common.errorLoadingData')}
        icon={<ExclamationCircleOutlined />}
        error={new Error(t('common.invalidIdProvided'))}
        resetErrorBoundary={() => {}}
      />
    );
  }

  if (error) {
    return (
      <>
        <PageTitle title={t('crud.details.title', { entity: 'Workflow' })} />
        <HeaderRow
          title={t('crud.details.title', { entity: 'Workflow' })}
          showBackButton={true}
          trailTarget={id}
        />
        <ErrorFallback
          details={t('common.errorLoadingData')}
          icon={<ExclamationCircleOutlined />}
          error={error}
          resetErrorBoundary={() => {}}
        />
      </>
    );
  }

  return (
    <>
      <PageTitle title={t('crud.details.title', { entity: 'Workflow' })} />
      <HeaderRow
        title={t('crud.details.title', { entity: 'Workflow' })}
        showBackButton={true}
        trailTarget={id}
      />
      <div className="row mt-3">
        <WorkflowDetailsComponent
          data={data?.data}
          success={data?.success ?? false}
          isLoading={isLoading}
          error={error}
        />
      </div>
    </>
  );
};

export default WithPermissionCheck(memo(WorkflowDetailsContainer), 'workflow.view');
